// import { z } from "zod";

export const firebaseConfig = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyD2lKFZr-wxvYaqHuOSIPkYZkEd8QWYHZU",
    authDomain: "parafolio-2c523.firebaseapp.com",
    projectId: "parafolio-2c523",
    storageBucket: "parafolio-2c523.appspot.com",
    messagingSenderId: "1076933796429",
    appId: "1:1076933796429:web:6e545e4bec0909281bb204",
    measurementId: "G-P2DMC3M4T2",
  },
};

// const envSchema = z.object({
//   VITE_AUTH_SERVER_BASE_URL: z.string(),
//   VITE_PARAFOLIO_SERVER_BASE_URL: z.string(),
//   VITE_PARAPASS_SERVER_BASE_URL: z.string(),
//   VITE_JRCALC_PLUS_SERVER_BASE_URL: z.string(),
//   VITE_PARAFOLIO_CONFIG_SERVER_BASE_URL: z.string(),
//   VITE_JRCALC_PLUS_DEEPLINK_URL: z.string(),
//   VITE_PARAPASS_DEEPLINK_URL: z.string(),
// });

// // export const env = envSchema.parse(process.env);
